import React from 'react';
import KidsHeroWrap from "./style/pink";
import Container from "../../components/paper/container";
import SectionTitle from "../../components/heading/section";
import P1 from "../../components/paragraph";

const KidsHero = () => {
    return (
        <KidsHeroWrap>
            <Container>
                <SectionTitle>
                    More blacks locked up under Joe Biden Crime Bill than all of
                </SectionTitle>
                <h4>Slavery</h4>
                <P1>
                    Four generations of black families have been destroyed by Joe Biden's Crime Bill and to this day
                    they suffer.
                </P1>
            </Container>
        </KidsHeroWrap>
    );
};

export default KidsHero;